import Vue from 'vue'

import { useCentrifugo } from '@/composables/useCentrifugo'
import { notificationService } from '@/utils/notifications'
import { $themeConfig } from '@themeConfig'

const { rpc } = useCentrifugo()

const sendRpc = (method, data, errorTitle) =>
    rpc(method, data).catch(error => {
        console.error(`Centrifugo RPC ${method} failed`, error)
        notificationService.showError(error, errorTitle, { timeout: false })
    })

export default {
    fetchSessions({ commit }) {
        return new Promise((resolve, reject) => {
            Vue.axios
                .get(`${$themeConfig.app.backUrl}/sessions`)
                .then(response => {
                    commit('SET_SESSIONS', response.data)
                    resolve(response.data)
                })
                .catch(error => {
                    commit('SET_SESSIONS', null)
                    reject(error)
                })
        })
    },
    setStatus(_, status) {
        return sendRpc(
            'session.set_status',
            { status },
            'Не удалось обновить статус оператора'
        )
    },
    setChannel(_, channel) {
        return sendRpc(
            'session.set_channel',
            { channel },
            'Не удалось обновить канал оператора'
        )
    },
}
